import React, { useCallback, useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";

import EasyIcon from "assets/icons/basicTechinc.png";
import MiddleIcon from "assets/icons/middleTechnic.png";
import HardIcon from "assets/icons/hardTechnic.png";

import "./PracticeByTechniqueMobile.scss";
import Checkbox from "common/components/Checkbox";

interface IData {
  Id_ExSubject: number;
  SbjCategoryID: number;
  SbjIndex: number;
  SubjectName: string;
}

interface IValue {
  Data: IData;
}

interface Props {
  type?: "deffense" | "hand_play";
  search?: string;
  listChecked?: any;
  onChecked?: (val?: any, item?: any) => void;
  data?: {
    basic: IValue[];
    middle: IValue[];
    hard: IValue[];
  };
  onStartPractice?: () => void;
}

const PracticeByTechniqueMobile = ({
  type = "hand_play",
  search,
  listChecked,
  onChecked,
  data,
  onStartPractice
}: Props) => {
  const [activeKey, setActiveKey] = useState<string | null>(null);

  const renderList = useCallback(
    (type: string) => {
      return (
        <>
          {data[type].map((val: IValue) => {
            //filter items
            if (search && val?.Data?.SubjectName.indexOf(search) === -1) {
              return null;
            }
            return (
              <Checkbox
                key={val.Data?.Id_ExSubject}
                label={val?.Data?.SubjectName}
                style={{ fontSize: 24 }}
                onClick={(item) => {
                  onChecked && onChecked(val, item);
                }}
              />
            );
          })}
        </>
      );
    },
    [data, onChecked, search]
  );

  //this helps open accordion items if at least one listitem exist in basic/middle/hard
  useEffect(() => {
    if (search) {
      const firstMatch = data?.basic?.some((val: IValue) => val?.Data?.SubjectName.includes(search))
        ? "0"
        : data?.middle?.some((val: IValue) => val?.Data?.SubjectName.includes(search))
        ? "1"
        : data?.hard?.some((val: IValue) => val?.Data?.SubjectName.includes(search))
        ? "2"
        : null;

      setActiveKey(firstMatch);
    } else {
      setActiveKey(null); // helps to close all items if search is empty
    }
  }, [search, data]);

  return (
    <div className="practice-techinque-mobile-wrapper">
      <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(key ? String(key) : null)}>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <div className="practice-techinque-mobile-header-item">
              <img src={EasyIcon} />
              <span>{type === "deffense" ? "טכניקות בסיסיות" : "טכניקות משחק כלליות"}</span>
            </div>
          </Accordion.Header>
          <Accordion.Body>{renderList("basic")}</Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>
            <div className="practice-techinque-mobile-header-item">
              <img src={MiddleIcon} />
              <span>{type === "deffense" ? "איתותים" : "טכניקות משחק בשליט"}</span>
            </div>
          </Accordion.Header>
          <Accordion.Body>{renderList("middle")}</Accordion.Body>
        </Accordion.Item>
        {data?.hard?.length > 0 && (
          <Accordion.Item eventKey="2">
            <Accordion.Header>
              <div className="practice-techinque-mobile-header-item">
                <img src={HardIcon} />
                <span>{type === "deffense" ? "טכניקות מתקדמות" : "טכניקות משחק מתקדמות"}</span>
              </div>
            </Accordion.Header>
            <Accordion.Body>{renderList("hard")}</Accordion.Body>
          </Accordion.Item>
        )}
      </Accordion>
      <div className="practice-techinque-mobile-btn-container">
        <button
          className={`practice-techinque-mobile-btn ${
            listChecked.length <= 0 ? "practice-techinque-mobile-btn-disable" : ""
          }`}
          onClick={listChecked.length > 0 ? () => onStartPractice && onStartPractice() : undefined}>
          התחילו לתרגל
        </button>
      </div>
    </div>
  );
};

export default PracticeByTechniqueMobile;
